<section>
  @if (steps.length > 1) {
    <div class="stepper-dot-container">
      @for (step of steps; track $index; let i = $index) {
        <button
          class="stepper-dot"
          [attr.data-testid]="'step-' + (i + 1) + '-button'"
          [ngClass]="{
            'step-current': isCurrentStep(i),
            'step-completed': isStepCompleted(step, i),
            'step-error': isStepError(step, i),
          }"
          (click)="onStepChange(i)"
        >
          @if (isCurrentStep(i)) {
            <span class="step-index">{{ i + 1 }}</span>
            {{ step.label }}
          } @else if (isStepCompleted(step, i)) {
            <mat-icon [svgIcon]="IconNames.ice_checkmark" />
          } @else if (isStepError(step, i)) {
            <mat-icon [svgIcon]="IconNames.ice_close_thick" />
          } @else {
            {{ i + 1 }}
          }
        </button>
      }
    </div>
  }

  <div [style.display]="selected ? 'block' : 'none'">
    <ng-container [ngTemplateOutlet]="selected?.content" />
  </div>

  @if (hasCustomNavigation) {
    <footer class="step-navigation-footer">
      @if (selectedIndex !== 0) {
        <app-ice-button
          cdkStepperPrevious
          color="outlined"
          testId="ice-stepper-previous-button"
          (click)="onStepChange(selectedIndex - 1)"
        >
          Tilbake
        </app-ice-button>
      }
      @if (selectedIndex + 1 === steps.length) {
        <app-ice-button
          testId="ice-stepper-finish-button"
          [color]="hasVisualFinalStep ? 'primary' : 'secondary'"
          (click)="isFinished.emit(true)"
        >
          {{ hasVisualFinalStep ? 'Ferdig' : 'Neste' }}
        </app-ice-button>
      } @else {
        <app-ice-button
          color="secondary"
          testId="ice-stepper-next-button"
          (click)="onStepChange(selectedIndex + 1)"
        >
          Neste
        </app-ice-button>
      }
      @if (isCancelable) {
        <app-ice-button color="outlined" testId="ice-stepper-cancel" (click)="cancelStepper.emit()">Avbryt</app-ice-button>
      }
    </footer>
  }
</section>
